
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 30 30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"15","cy":"15","r":"14.25","fill":"#DDD","stroke":"#fff","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M16.828 22.624v-.004l-.016-1.049c1.007-.186 1.823-.596 2.432-1.242.637-.676.95-1.532.95-2.547 0-.798-.197-1.474-.61-2.007-.391-.505-.839-.89-1.344-1.15-.48-.246-1.126-.52-1.935-.821h0l-.002-.001c-.73-.264-1.26-.476-1.596-.638-.328-.158-.56-.325-.71-.495a.902.902 0 01-.193-.594c0-.352.122-.607.356-.795.241-.192.598-.305 1.104-.305.64 0 1.114.167 1.452.475h0l.003.003c.345.303.509.662.509 1.09v.144c0 .114.036.22.104.312l.021.029.029.021a.513.513 0 00.312.104h1.962c.114 0 .23-.036.32-.127a.473.473 0 00.146-.339v-.27c0-1.015-.313-1.886-.945-2.595-.606-.693-1.411-1.147-2.401-1.37l.016-1.234h0v-.003a.42.42 0 00-.144-.322.42.42 0 00-.322-.144h-1.8a.473.473 0 00-.339.145.444.444 0 00-.127.321h0v.007l.033 1.193c-.939.198-1.707.609-2.289 1.24h0c-.6.653-.894 1.478-.894 2.456 0 .774.191 1.446.587 2h0l.004.005c.393.52.87.933 1.43 1.238.542.296 1.208.583 1.994.861.681.263 1.169.47 1.47.62h0l.01.005c.3.133.52.288.67.458h0l.005.006a.763.763 0 01.202.549c0 .324-.119.594-.37.824-.221.203-.597.33-1.18.33-.696 0-1.211-.154-1.573-.433-.368-.294-.535-.633-.535-1.027v-.27a.42.42 0 00-.144-.322.42.42 0 00-.322-.144h-1.944a.473.473 0 00-.339.145.444.444 0 00-.127.321v.396c0 1.014.306 1.874.929 2.562h0l.002.002c.607.657 1.424 1.091 2.433 1.312l-.016 1.07h0v.004c0 .114.036.23.127.32a.473.473 0 00.339.146h1.8a.42.42 0 00.322-.144.42.42 0 00.144-.322z","fill":"#19052B","stroke":"#fff","stroke-width":".5"}})])
          )
        }
      }
    